import React from 'react';
import { useIntl } from 'react-intl-next';

import { token } from '@atlaskit/tokens';

import { useChoreographerAssets } from '@confluence/choreographer-services';

import type { TourStepComponent } from '../../hooks/useCombinedSegments';
import { CrossIconCloseButton } from '../../common/CrossIconCloseButton';
import { useSpotlightActions } from '../../hooks/useSpotlightActions';
import { lastUpdatedSpotlight } from '../../messages';

export const LAST_UPDATED_SPOTLIGHT_TARGET = 'content-wrapper-last-updated-spotlight-target';
export const LAST_UPDATED_SPOTLIGHT_NAME = 'content-wrapper-last-updated-spotlight';

const LastUpdatedSpotlight: TourStepComponent = ({ onNext, onBack, onDismiss, progress }) => {
	const { Spotlight } = useChoreographerAssets();
	const { formatMessage } = useIntl();

	const { actions, actionsBeforeElement } = useSpotlightActions({
		progress,
		onNext,
		onBack,
		source: LAST_UPDATED_SPOTLIGHT_NAME,
	});

	return (
		<Spotlight
			actions={actions}
			actionsBeforeElement={actionsBeforeElement}
			dialogPlacement="bottom right"
			dialogWidth={300}
			heading={formatMessage(lastUpdatedSpotlight.heading)}
			headingAfterElement={
				<CrossIconCloseButton onClose={onDismiss} source={LAST_UPDATED_SPOTLIGHT_NAME} />
			}
			key={LAST_UPDATED_SPOTLIGHT_NAME}
			messageId={LAST_UPDATED_SPOTLIGHT_NAME}
			messageType="engagement"
			shouldWatchTarget
			target={LAST_UPDATED_SPOTLIGHT_TARGET}
			targetBgColor={token('elevation.surface')}
			targetRadius={4}
		>
			{formatMessage(lastUpdatedSpotlight.body, {
				a: (chunks: React.ReactNode) => (
					<span>{chunks}</span> // TODO: link to community post
				),
			})}
		</Spotlight>
	);
};

export const Spotlights = {
	LastUpdatedSpotlight,
};
